import type { ReactNode } from 'react'
import { Link } from '@tanstack/react-router'
import { useLingui } from '@lingui/react/macro'
import { AuthCard } from '@/routes/_app/-components/shared/auth-card'

// Shared shell for the password-recovery pages (begin reset / set new password): an AuthCard with the
// fixed "Remember your password? Login" footer those two pages share.
export function PasswordAuthLayout(props: { title: string; subtitle: string; children: ReactNode }) {
  const { t } = useLingui()
  return (
    <AuthCard
      title={props.title}
      subtitle={props.subtitle}
      footer={
        <>
          {t`Remember your password?`}{' '}
          <Link to="/login" className="text-primary font-medium hover:underline">
            {t`Login`}
          </Link>
        </>
      }
    >
      {props.children}
    </AuthCard>
  )
}
